import { motion } from "framer-motion";
import { Phone, MessageCircle, TrendingUp } from "lucide-react";

import Button from "../../Button/Button";
import Container from "../../Container/Container";
import hero from "../../../Assets/images/hero.webp";
import { fadeRight, fadeUp, floating, staggerContainer } from "../../../Utils/animations";
import { heroMetrics } from "../../../Data/heroData";

import "../../../Style/home/hero.css";

const barHeights = [38, 62, 48, 82, 58, 94, 70];

function Hero() {
  const handleContactClick = (e) => {
    e.preventDefault();
    if (window.location.pathname === "/contact") return;
    window.history.pushState({}, "", "/contact");
    window.dispatchEvent(new Event("popstate"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section id="home" className="hero section section--flush-top section--grid">
      {/* Background Dummy Image & Dimmer Overlay */}
      <div className="hero__bg-media" aria-hidden="true">
        <img
          src={hero}
          alt=""
          aria-hidden="true"
          className="hero__bg-img"
        />
        <div className="hero__bg-overlay" />
      </div>

      <Container className="hero__inner">
        <motion.div
          className="hero__content"
          variants={staggerContainer(0.12, 0.15)}
          initial="hidden"
          animate="show"
        >
          <motion.span className="section-eyebrow" variants={fadeUp(0)}>
            <span className="section-eyebrow__dot" aria-hidden="true" />
            Data · Digital · Growth
          </motion.span>

          <motion.h1 className="hero__title" variants={fadeUp(0.05)}>
            Conectify Tech
            <br />
            is Here for All Your <span className="text-gradient">Leads &amp; Solutions.</span>
          </motion.h1>

          <motion.p className="hero__description" variants={fadeUp(0.1)}>
            Get customized Business Emails Lists to enhance your deals with our focused-on industry mailing records. Assemble your customers data set with our great potential business contacts, everything being equal.
          </motion.p>

          <motion.div className="btn-row hero__actions" variants={fadeUp(0.15)}>
            {/* Direct Call Button (Replace with your actual business number) */}
            <Button
              href="tel:+17867762152"
              icon={<Phone size={18} />}
            >
              Call Us Now
            </Button>

            {/* Direct Contact Page Navigation */}
            <Button
              href="/contact"
              variant="outline"
              icon={<MessageCircle size={18} />}
              onClick={handleContactClick}
            >
              Talk to an Expert
            </Button>
          </motion.div>
        </motion.div>

        <motion.div
          className="hero__visual"
          variants={fadeRight(0.3, 56)}
          initial="hidden"
          animate="show"
        >
          <motion.div className="hero__panel" {...floating(10, 6)}>
            <div className="hero__panel-head">
              <span className="hero__panel-dot" />
              <span className="hero__panel-dot" />
              <span className="hero__panel-dot" />
              <span className="hero__panel-label">Growth Dashboard</span>
            </div>

            <div className="hero__panel-body">
              <div className="hero__chart" role="img" aria-label="Rising conversion trend chart">
                {barHeights.map((height, index) => (
                  <motion.span
                    key={index}
                    className="hero__chart-bar"
                    initial={{ height: 0 }}
                    animate={{ height: `${height}%` }}
                    transition={{ duration: 0.8, delay: 0.6 + index * 0.06, ease: "easeOut" }}
                  />
                ))}
              </div>

              <div className="hero__panel-footer">
                <TrendingUp size={16} />
                <span>Conversions trending up this quarter</span>
              </div>
            </div>
          </motion.div>

          {heroMetrics.map((metric, index) => (
            <motion.div
              key={metric.id}
              className={`hero__metric hero__metric--${index}`}
              variants={fadeUp(0.9 + index * 0.12, 16)}
              initial="hidden"
              animate="show"
            >
              <motion.div {...floating(8 + index * 2, 4.5 + index * 0.6)}>
                <span className="hero__metric-value">{metric.value}</span>
                <span className="hero__metric-label">{metric.label}</span>
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </Container>
    </section>
  );
}

export default Hero;